<template>
  <ws-list-view-item-column class="ws-orgs__item">
    <header class="ws-orgs__item-header">
      <div class="ws-orgs__item-title">
        <router-link :to="`/orgs/${item.guid}/groups`">
          <h2 class="is-size-3 has-text-primary has-text-weight-bold" v-text="item.title.display"></h2>
        </router-link>
        <address>
          <span v-if="item.address.locality && item.address.locality.title && item.address.locality.title.display">{{ item.address.locality.title.display }}, &nbsp;</span>
          <span>{{ item.address.address.display }}</span>
        </address>
      </div>
      <div class="ws-orgs__item-meta">
        <dl v-if="item.inn && item.inn.length">
          <dt>{{$t('ИНН')}}</dt>
          <dd>{{item.inn}}</dd>
        </dl>
        <dl v-if="item.kpp && item.kpp.length">
          <dt>{{$t('КПП')}}</dt>
          <dd>{{item.kpp}}</dd>
        </dl>
      </div>
      <div class="ws-orgs__item-region">
        <ws-icon
          class="ws-button__icon is-position-left"
          name="geo-marker"
          color="#6D9AE8"
          width="12"
          height="16"
        />
        <span v-if="item.address.region" class="ws-button__text has-text-info">
          {{ item.address.region.title.display }}
        </span>
      </div>
    </header>
    <ws-curator-list :curators="newCurators" style="margin: 20px"/>
    <footer class="ws-orgs__item-footer">
      <div class="ws-orgs__item-footer-column">
        <button class="ws-button button is-text" @click="showCuratorsManagementPopup(item)">
          <ws-icon
            class="ws-button__icon is-position-left"
            name="user-fav"
            :title="$t('Назначить куратора')"
            color="#1c3b8d"
            width="18"
            height="18"
          />
          <span class="ws-button__text has-text-primary is-hidden-touch" v-text="$t('Назначить куратора')"></span>
        </button>
      </div>
      <div class="ws-orgs__item-footer-column">
        <router-link :to="`/orgs/${item.guid}/groups`" class="ws-button button is-text">
          <span class="has-text-weight-bold has-text-primary is-hidden-touch" v-text="$t('Группы')"></span>
          <span class="is-hidden-touch">&nbsp;</span>
        </router-link>
      </div>
    </footer>
  </ws-list-view-item-column>
</template>

<script>
import WsCuratorsManagement from '@/components/de/orgs/modals/WsCuratorsManagement'
import { mapActions } from 'vuex'
import WsCuratorList from '@/components/de/demo-exams/WsCuratorList.vue'
export default {
  name: 'WsOrgsListItem',
  props: {
    curators: Array,
    item: Object
  },
  data () {
    return {
      groups: [],
      newCurators: []
    }
  },
  components: {
    WsCuratorList
  },
  computed: {
  },
  watch: {
    curators: {
      handler (curators) {
        this.newCurators = curators || []
      }
    }
  },
  methods: {
    ...mapActions('refbook/study_groups', {
      'findGroups': 'find'
    }),
    showCuratorsManagementPopup (org) {
      this.$buefy.modal.open({
        parent: this,
        component: WsCuratorsManagement,
        hasModalCard: true,
        props: {
          org,
          curators: this.newCurators
        },
        canCancel: false,
        events: {
          'updateCurators': curators => {
            this.newCurators = [...curators]
          }
        }
      })
    }
  }
}
</script>
